import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAnnouncementActionClicked.meta';

export type UseTrackAnnouncementActionClickedParams = {
  action_label: string;
  action_type: 'button' | 'link';
  announcement_id: string;
  name: string;
  surface:
    | 'global'
    | 'assetDetails'
    | 'canvas'
    | 'canvasNullState'
    | 'canvasChatComposer'
    | 'boards'
    | 'plans'
    | 'news';
};

export const useTrackAnnouncementActionClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackAnnouncementActionClicked = useCallback(
    (params: UseTrackAnnouncementActionClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAnnouncementActionClicked };
};
